module.exports = __webpack_public_path__ + "static/media/medicare-101-thumb.e09f3af8.jpg";